import React, { FC } from 'react';
import { InfoStatus, TimesheetApproved } from 'api/notifications/meta';
import { ReactComponent as ErrorNoteIcon } from 'assets/svgs/timesheet_error_note.svg';
import { ApprovalComment } from '../approval-comment';

export const TimesheetComment: FC<{ meta: TimesheetApproved }> = ({ meta }) => {
  if (meta.info?.status === InfoStatus.Rejected) {
    if (meta.info?.notes && meta.info?.notes.length === 1) {
      return (
        <ApprovalComment
          content={meta.info?.notes[0].noteText}
          icon={<ErrorNoteIcon />}
          background="var(--coolest-gray-10)"
        />
      );
    }
  }

  if (meta.info?.status === InfoStatus.PartiallyApproved) {
    if (meta.info?.notes && meta.info?.notes.length > 0) {
      return (
        <ApprovalComment
          content={meta.info?.notes[0].noteText}
          icon={<ErrorNoteIcon />}
          background="var(--coolest-gray-10)"
        />
      );
    }
  }

  return null;
};
